
import './App.css';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import AllRoutes from './Routes/AllRoutes';

function App() {
  return (
    <div className="App">
      {/* <div className="App-header" > */}
      <BrowserRouter>
      <ChakraProvider>
        <AllRoutes/>
      </ChakraProvider>
      </BrowserRouter>
     </div>
    // </div>
  );
}

export default App;
{/* <BrowserRouter><NavBar/> <AllRoutes/></BrowserRouter> */}